import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const volumes = [{
  title: 'FOUNDATION PHASE',
  description: 'Build confidence, coordination, and basketball fundamentals from day one.',
  meta: ['Ages 8-11', '30 Complete Sessions']
}, {
  title: 'SKILL DEVELOPMENT PHASE',
  description: 'Advanced ball handling, shooting development, passing progression, finishing skills, footwork, and 1v1 mastery.',
  meta: ['Ages 12-13', '30 Complete Sessions']
}, {
  title: 'GAME INTELLIGENCE PHASE',
  description: 'Decision making, spacing, off-ball movement, transition IQ, and basketball understanding.',
  meta: ['Ages 14-15', '30 Complete Sessions']
}, {
  title: 'TEAM DEVELOPMENT PHASE',
  description: 'Team offense, team defense, transition play, competitive situations, and team roles.',
  meta: ['Ages 16-17', '30 Complete Sessions']
}, {
  title: 'THE 365 PRACTICE VAULT',
  description: 'Ready-to-use practices for every coaching situation. Low attendance. Limited equipment. Limited space. Special events. Emergency practices.',
  meta: ['30 Complete Practices']
}, {
  title: 'COACH SUCCESS SYSTEM',
  description: 'Season planning. Player development. Leadership. Parent management. Team management. Season success.',
  meta: ['30 Complete Coaching Systems']
}];
export function Volumes() {
  return <section className="py-20 bg-navy-950 relative" data-id="element-258">
      <div className="container mx-auto px-4" data-id="element-259">
        <div className="text-center mb-16" data-id="element-260">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-261">
            THE COMPLETE 6-VOLUME SYSTEM
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-262">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-700 rounded-xl p-8 relative overflow-hidden group hover:border-gold-500/50 transition-colors" data-id="element-263">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-264">
                <BookOpen className="w-24 h-24 text-white" data-id="element-265" />
              </div>
              <div className="relative z-10" data-id="element-266">
                <div className="text-gold-500 font-oswald text-sm tracking-widest mb-2" data-id="element-267">
                  VOLUME {index + 1}
                </div>
                <h3 className="font-anton text-2xl text-white uppercase tracking-wide mb-4" data-id="element-268">
                  {vol.title}
                </h3>
                <p className="text-gray-400 font-medium leading-relaxed mb-5" data-id="element-269">
                  {vol.description}
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-270">
                  {vol.meta.map((m, i) => <span key={i} className="inline-flex items-center font-oswald text-xs uppercase tracking-widest text-gold-400 bg-gold-500/10 border border-gold-500/30 rounded-full px-3 py-1" data-id="element-271">
                      {m}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}